module.exports = "#define GLSLIFY 1\n#ifdef USE_SPECULARMAP\n\n\tuniform sampler2D specularMap;\n\n#endif"